import { fetchCurrentUser } from "@/api/parse";
import { Cloud } from ".";
import { UserSession } from "../user/User";

export async function login({
  username,
  password,
  promoCode,
  installationId
}: {
  username: string;
  password: string;
  promoCode?: string;
  installationId?: string;
}): Promise<{ user: User; promoCodeError?: any } | null> {
  const result = (await Cloud.run("logInWeb", {
    username,
    password,
    promoCode,
    _InstallationId: installationId
  })) as { user: User; promoCodeError?: any } | null;

  if (result && "user" in result) {
    UserSession.set(result.user);
    result.user.accountInfo = await getAccountInfo();
    UserSession.set(result.user);
  }
  return result;
}

export function logout() {
  return Cloud.run("signOutWeb");
}

export async function signup({
  email,
  password,
  familyName,
  promoCode
}: {
  email: string;
  password: string;
  familyName?: string;
  promoCode?: string;
}): Promise<{ promoCodeError?: any } | { err: string }> {
  let response: { sessionToken: string; promoCodeError?: any };
  try {
    response = await Cloud.run("createAccount", { email, password, familyName, promoCode }, { rethrow: true });
  } catch (err) {
    return { err: (err as any)?.message };
  }

  if (response && response.sessionToken) {
    const user = await fetchCurrentUser(response.sessionToken);
    UserSession.set(user);
    user.accountInfo = await getAccountInfo();
    UserSession.set(user);
    return response;
  }

  return { err: "failure" };
}

export function accountDelete({ email, password }: { email: string; password: string }) {
  return Cloud.run("deleteAccountWeb", { email, password });
}

export function cameritoAccountDelete() {
  return Cloud.run("deleteAccountSendEmail");
}

export function changePassword({
  password,
  newPassword,
  repeatedPassword
}: {
  password: string;
  newPassword: string;
  repeatedPassword: string;
}) {
  return Cloud.run("setNewPassword", {
    password,
    newPassword,
    repeatedPassword
  });
}

export function updateUser({ fieldToUpdate, newValue }: { fieldToUpdate: string; newValue: string | number }) {
  return Cloud.run(UserSession.get()!.objectId, { [fieldToUpdate]: newValue }, { path: "users", method: "PUT" });
}

export function resetPassword({ email }: { email: string }) {
  return Cloud.run("requestPasswordReset", { email }, { path: "" });
}

export function checkEmailAuthentication({ email }: { email: string }) {
  return Cloud.run("checkEmailAuthentication", { email });
}

export function loginWithGoogle({ idToken }: { idToken: string }) {
  return Cloud.run("logInWithGoogleWeb", { idToken });
}

export function loginWithApple({
  idToken,
  authorizationCode,
  redirectUrl
}: {
  idToken: string;
  authorizationCode: string;
  redirectUrl: string;
}) {
  return Cloud.run("logInWithAppleWeb", {
    idToken,
    authorizationCode,
    redirectUrl
  });
}

export function getAccountInfo(): Promise<UserAccountInfo> {
  return Cloud.run("getCloudAccountInfo");
}

export function getMonitorings({ skip, limit }: { skip: number; limit?: number } = { skip: 0, limit: 20 }) {
  return Cloud.run("getCompleteActivityLogEntries", { skip, limit });
}

export async function getAvatars() {
  const response = (await Cloud.run("getAvatars")) as Avatar[] | null;

  if (response && typeof response === "object") {
    return {
      byId: response.reduce(
        (all, one) => {
          all[one.objectId] = one;
          return all;
        },
        {} as { [key: string]: Avatar }
      )
    };
  }
  return response;
}
